module.exports = __webpack_public_path__ + "img/ico-main-search.90110625.svg";